import { render, staticRenderFns } from "./Diagnosis.vue?vue&type=template&id=1c83341f"
import script from "./Diagnosis.vue?vue&type=script&lang=ts"
export * from "./Diagnosis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports